import React, { createContext, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { selectUser } from '../../reducers/UserReducer'
import { getStudentById, getStudentFreeFields, getStudentSchoolOptions } from '../../utils/api/student'
import { getAllSchools } from '../../utils/api/school'
import { getAllInstitutions } from '../../utils/api/institution'
import { resolvePromises } from '../../utils/apiHelper'

export const StudentContext = createContext()

const StudentProvider = ({ children }) => {
  const user = useSelector(selectUser)

  const [freefields, setFreefields] = useState({})
  const [schoolOptions, setSchoolOptions] = useState({})
  const [student, setStudent] = useState(null)
  const [institutions, setInstitutions] = useState([])
  const [schools, setSchools] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (user.student) {
      const promiseStack = []

      getStudentFreeFields(user.student, user, { contexts: ['institution'] }).then(json => {
        if (json?.data) {
          const freefields = {}

          json.data.forEach(sff => {
            if (!freefields[sff.fieldType.institution.id]) {
              freefields[sff.fieldType.institution.id] = []
            }

            freefields[sff.fieldType.institution.id].push(sff)
          })

          setFreefields(freefields)
        }
      })
      promiseStack.push(getStudentById(user, user.student))
      promiseStack.push(getStudentSchoolOptions(user, user.student))
      promiseStack.push(getAllSchools(user))
      promiseStack.push(getAllInstitutions(user, { deleted: false }))

      resolvePromises(promiseStack).then(([student, schoolOptions, schools, institutions]) => {
        if (student?.data) {
          setStudent(student?.data)
        }
        if (schoolOptions?.data) {
          setSchoolOptions(schoolOptions?.data)
        }
        if (schools?.data) {
          setSchools(schools?.data)
        }
        if (institutions?.data) {
          setInstitutions(institutions?.data)
        }

        setLoading(false)
      })
    } else {
      setFreefields({})
      setSchoolOptions({})
      setStudent(null)
      setInstitutions([])
      setSchools([])
      setLoading(false)
    }
  }, [user.student])

  return (
    <StudentContext.Provider
      value={{ freefields, institutions, loading, schoolOptions, schools, student, setStudent }}
    >
      {children}
    </StudentContext.Provider>
  )
}

export default StudentProvider
